<template>
  <div>
    <custom-actions>
      <template #header>
        <el-button v-if="hasExport" type="primary" @click="onDownExcel">导出</el-button>
        <el-button v-if="hasAdd" type="primary" @click="$router.push('/typeQcReport/add')">新增</el-button>
      </template>
      <el-form inline ref="searchFormRef" class="global-form-label-width" :model="searchForm">
        <el-form-item label="品种规格" prop="specName">
          <el-input clearable v-model="searchForm.specName" placeholder="请输入品种规格" />
        </el-form-item>
        <el-form-item prop="manufacturerName" label="生产商">
          <el-input clearable v-model="searchForm.manufacturerName" placeholder="请输入生产商" />
        </el-form-item>
        <el-form-item prop="productionDate" label="生产日期">
          <el-date-picker
            v-model="searchForm.productionDate"
            placeholder="请选择生产日期"
            type="date"
            clearable
            format="yyyy-MM-dd"
            value-format="yyyy-MM-dd"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item prop="inspectionDate" label="送检日期">
          <el-date-picker
            v-model="searchForm.inspectionDate"
            placeholder="请选择送检日期"
            type="date"
            clearable
            format="yyyy-MM-dd"
            value-format="yyyy-MM-dd"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item prop="issueDate" label="签发日期">
          <el-date-picker
            v-model="searchForm.issueDate"
            placeholder="请选择签发日期"
            type="date"
            clearable
            format="yyyy-MM-dd"
            value-format="yyyy-MM-dd"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item prop="createTime" label="创建时间">
          <el-date-picker
            v-model="dateArr"
            @change="changeDate"
            type="datetimerange"
            range-separator="至"
            start-placeholder="开始时间"
            end-placeholder="结束时间"
            clearable
            format="yyyy-MM-dd HH:mm:ss"
            value-format="yyyy-MM-dd HH:mm:ss"
          >
          </el-date-picker>
        </el-form-item>

        <el-form-item>
          <el-button type="primary" @click="onSearch">查询</el-button>
          <el-button @click="resetForm">重置</el-button>
        </el-form-item>
      </el-form>
    </custom-actions>

    <el-card class="mt10" shadow="never">
      <el-table size="mini" stripe border v-loading="loading" :data="tableData">
        <el-table-column show-overflow-tooltip min-width="140" label="品种规格" prop="specName"></el-table-column>
        <el-table-column show-overflow-tooltip min-width="140" label="生产商" prop="manufacturerName"></el-table-column>
        <el-table-column show-overflow-tooltip min-width="120" label="生产日期" prop="productionDate"></el-table-column>
        <el-table-column show-overflow-tooltip min-width="120" label="送检日期" prop="inspectionDate"></el-table-column>
        <el-table-column show-overflow-tooltip min-width="120" label="签发日期" prop="issueDate"></el-table-column>
        <el-table-column show-overflow-tooltip min-width="120" label="备注" prop="remark"></el-table-column>
        <el-table-column show-overflow-tooltip min-width="120" label="创建人" prop="createUserName"></el-table-column>
        <el-table-column show-overflow-tooltip min-width="180" label="创建时间" prop="ctime"></el-table-column>

        <el-table-column fixed="right" label="操作" width="160">
          <template v-slot="{ row }">
            <el-button
              type="text"
              @click="$router.push('/typeQcReport/detail?reportId=' + row.reportId)"
            >
              详情
            </el-button>
            <el-button
              type="text"
              v-if="hasEdit"
              @click="$router.push('/typeQcReport/edit?reportId=' + row.reportId)"
            >
              编辑
            </el-button>
            <el-button type="text" v-if="hasDel" @click="deleteRow(row.reportId)" class="del-btn">删除</el-button>
          </template>
        </el-table-column>
      </el-table>

      <el-pagination
        :current-page.sync="page"
        background
        layout="total, prev, pager, next"
        :total="total"
        @current-change="loadData"
      >
      </el-pagination>
    </el-card>
  </div>
</template>

<script>
export default {
  name: 'typeQcReport',
  data() {
    return {
      page: 1,
      total: 0,
      tableData: [],
      loading: false,
      dateArr: [],
      searchForm: {
        specName: null,
        manufacturerName: null,
        productionDate: null,
        inspectionDate: null,
        issueDate: null,
        remark: null,
        startTime: '',
        endTime: ''
      }
    }
  },
  computed: {
    buttonList() {
      return this.$store.state.buttonList.map((item) => item.butCode)
    },
    hasAdd() {
      return this.buttonList.includes('add')
    },
    hasEdit() {
      return this.buttonList.includes('edit')
    },
    hasDel() {
      return this.buttonList.includes('delete')
    },
    hasExport() {
      return this.buttonList.includes('export')
    }
  },
  created() {
    this.loadData()
  },
  methods: {
    changeDate(date) {
      if (date && date.length) {
        this.searchForm.startTime = date[0]
        this.searchForm.endTime = date[1]
      } else {
        this.searchForm.startTime = ''
        this.searchForm.endTime = ''
      }
    },
    loadData() {
      this.loading = true
      this.$axios
        .get(this.$apis.typeQcReport.selectPaTypeQcReportByPage, {
          params: {
            page: this.page,
            size: 10,
            ...this.searchForm
          }
        })
        .then((res) => {
          this.tableData = res.list || []
          this.total = res.total || 0
        })
        .finally(() => {
          this.loading = false
        })
    },
    onSearch() {
      this.page = 1
      this.loadData()
    },
    resetForm() {
      this.$refs.searchFormRef && this.$refs.searchFormRef.resetFields()
      this.searchForm = {
        specName: null,
        manufacturerName: null,
        productionDate: null,
        inspectionDate: null,
        issueDate: null,
        remark: null,
        startTime: '',
        endTime: ''
      }
      this.dateArr = []
      this.onSearch()
    },
    deleteRow(reportId) {
      this.$confirm('确认删除该记录, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.$axios
            .post(this.$apis.typeQcReport.deleteDataPaTypeQcReport, {
              reportId
            })
            .then(() => {
              this.loadData()
            })
        })
        .catch(() => {})
    },
    onDownExcel() {
      const loadingInstance = this.$loading({
        text: '正在导出...',
        background: 'rgba(0, 0, 0, 0.8)'
      })
      this.$axios
        .post(
          this.$apis.typeQcReport.exportPaTypeQcReport,
          {
            ...this.searchForm
          },
          {
            responseType: 'blob'
          }
        )
        .then((res) => {
          if (res) {
            const disposition = res.headers['content-disposition']
            const fileName = disposition.substring(disposition.indexOf('filename')).split('=')[1]
            this.downloadFile(res.data, fileName)
          }
        })
        .catch((error) => {
          console.error('导出失败:', error)
        })
        .finally(() => {
          loadingInstance.close()
        })
    },
    downloadFile(data, fileName) {
      const blob = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
      const downloadElement = document.createElement('a')
      const href = window.URL.createObjectURL(blob)
      downloadElement.href = href
      downloadElement.download = decodeURIComponent(fileName)
      document.body.appendChild(downloadElement)
      downloadElement.click()
      document.body.removeChild(downloadElement)
      window.URL.revokeObjectURL(href)
    }
  }
}
</script>

<style scoped lang='scss'>
.del-btn {
  color: #f56c6c;
}
</style>
